import React, { useState, useEffect } from 'react';
import './Slider.css';

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    { id: 1, image: '/img/slide1.png', alt: '日本租车' },
    { id: 2, image: '/img/slide2.png', alt: '日本租车' },
    { id: 3, image: '/img/slide3.png', alt: '日本租车' },
    { id: 4, image: '/img/slide4.png', alt: '日本租车' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="slider-wrap">
      <div className="slider">
        <ul className="slider-list">
          {slides.map((slide, index) => (
            <li
              key={slide.id}
              className={`item ${index === currentSlide ? 'active' : ''}`}
            >
              <a href="/" className="item-lk">
                <img className="item-img" src={slide.image} alt={slide.alt} />
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="pic">
        <div className="yuan">
          {slides.map((_, index) => (
            <i
              key={index}
              className={`yuan-item ${index === currentSlide ? 'cur' : ''}`}
              onClick={() => goToSlide(index)}
            ></i>
          ))}
        </div>
      </div>
      <div className="btn-group">
        <div className="btn-left" onClick={prevSlide}>
          {'<'}
        </div>
        <div className="btn-right" onClick={nextSlide}>
          {'>'}
        </div>
      </div>
    </div>
  );
};

export default Slider;
